module.exports = __webpack_public_path__ + "img/azul.ff2911c5.png";